import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { formatMessage } from '../../../translations/format-message';

interface Props {
  showConfirmSubmitModal: boolean;
  setShowConfirmSubmitModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleRemoveTray: () => void;
  isLoading: boolean;
  title: string;
  message: string;
  id?: string;
  error: string;
  isBatch: boolean;
}

const ProcessPauseConfirmPopup: React.FC<Props> = (props) => {
  const handleProcessCompleted = () => {
    props.setShowConfirmSubmitModal(false);
    props.handleRemoveTray();
  };

  return (
    <Modal
      show={props.showConfirmSubmitModal}
      centered
    >
      <Modal.Header>
        <Modal.Title>{formatMessage('confirmation')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {props.message}
        <div dangerouslySetInnerHTML={{ __html: props.error }} />
      </Modal.Body>

      <Modal.Footer>
        {props.showConfirmSubmitModal && (
          <>
            <Button
              variant="primary"
              onClick={handleProcessCompleted}
            >
              {formatMessage('ok')}
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ProcessPauseConfirmPopup;
